import { render, staticRenderFns } from "./EditEnterprise.vue?vue&type=template&id=2fb796e1&scoped=true"
import script from "./EditEnterprise.vue?vue&type=script&lang=js"
export * from "./EditEnterprise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb796e1",
  null
  
)

export default component.exports